<template>
	<v-row style="font-family: kalam">
		<v-container fluid>
			<v-col class="d-flex child-flex" cols="10" offset="1">
				<h1>{{ $t('contact.title') }}</h1>
			</v-col>
			<v-col cols="10" offset="1">
				<p class="text-center">{{ $t('contact.body') }}</p>
			</v-col>
			<v-row fluid>
				<v-col v-for="item in list" :key="item.id" cols="3" offset="2" class="d-flex child-flex">
					<a :href="item.link" target="_blank">
						<v-icon v-html="item.icon"></v-icon>
						{{ item.label }}
					</a>
				</v-col>
			</v-row>
		</v-container>
	</v-row>
</template>

<script>
import Constants from '../Constants'

export default {
	name: 'ContactComp',
	data: () => ({
		list: [
			{
				id: 1,
				icon: '$vuetify.icons.instagram',
				label: 'Instagram',
				link: Constants.links.instagram,
			},
			{
				id: 2,
				icon: '$vuetify.icons.facebook',
				label: 'Facebook',
				link: Constants.links.facebook,
			},
		],
	}),
}
</script>
